import React, { useEffect } from 'react';
import HealthcareBanner from './HealthcareBanner';

import Automotivemobilitecards from './Automotivemobilitecards';
import AutomobilityTabs from './AutomobilityTabs';
import Automobilityverticaltabs from './Automobilityverticaltabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import AerospaceanimatedCards from './AerospaceanimatedCards';
import AerospaceInsightsCards from './AerospaceInsightsCards';
import Industrypatners from './Industrypatners';
import Healthverticalcards from './Healthverticalcards';
import Healthcareanimatedcards from './Healthcareanimatedcards';
import HealthcareAboutdata from './HealthcareAboutdata';
import Helathcareimgehover from './Helathcareimgehover';
import Healthcarecards from './Healthcarecards';
import Healthcarebuttons from './Healthcarebuttons';
import Footer from './Footer';
import Itrequestform from './Itrequestform';
import Healthcareextradata from './Healthcareextradata';
import CregotHealcarpage from './CregotHealcarpage';
import HealthcareSecondVerticalTabs from './HealthcareSecondVerticalTabs';
import Healthcarecrigotmobile from './Healthcarecrigotmobile';
import Healthcarethirdtab from './Healthcarethirdtab';



const HealthCarepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>
      <HealthcareBanner />
      <Healthcarebuttons />
      <HealthcareAboutdata />

      <Healthverticalcards />
      <HealthcareSecondVerticalTabs />
      <Healthcarethirdtab />
      <Healthcareextradata />
      {/* <Healthcarecards  /> */}
      <CregotHealcarpage />
      <div className='mobile-crigot'>
        <Healthcarecrigotmobile />
      </div>

      {/* <AerospaceInsightsCards /> */}

      <br></br>
      <Itrequestform />
      <div style={{ marginTop: "-60px" }}>
        <Footer />
      </div>


      {/* <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style> */}
      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  )
}

export default HealthCarepage;